import React from "react";
import "./About.css";
import vid from "../videos/aboutus.mp4";

const About = () => {
  return (
    <div className="about">
      <video
          autoPlay
          loop
          muted
          src={vid}></video>
      <div className="aboutuslist">
          <p>Providing a safe harbor for</p>  
          <p> your data and a clear</p>
          <p> path for your business growth.</p>
      </div>
    </div>
  );
};

export default About;